/**
 * Country flags as bundled SVG files (country-flag-icons, 3:2).
 *
 * Emoji flags are not used: Windows renders them as two letters. Each flag
 * is emitted as its own asset and only fetched when shown, so the map below
 * holds URLs, not SVG markup.
 */
const FLAG_URLS = import.meta.glob<string>('/node_modules/country-flag-icons/3x2/*.svg', {
  eager: true,
  query: '?no-inline',
  import: 'default',
})

const FLAG_PATH_PREFIX = '/node_modules/country-flag-icons/3x2/'

/** URL of the flag SVG for an ISO-3166 alpha-2 code, or null when none exists. */
export function countryFlagUrl(code: string | null | undefined): string | null {
  if (!code) return null
  const upper = code.trim().toUpperCase()
  if (!/^[A-Z]{2}$/.test(upper)) return null
  return FLAG_URLS[`${FLAG_PATH_PREFIX}${upper}.svg`] ?? null
}

const markupCache = new Map<string, Promise<string | null>>()

/** Raw SVG markup for a flag, for standalone exports. Null when unavailable. */
export function fetchCountryFlagMarkup(code: string): Promise<string | null> {
  const url = countryFlagUrl(code)
  if (!url) return Promise.resolve(null)
  let pending = markupCache.get(url)
  if (!pending) {
    pending = fetch(url)
      .then((res) => (res.ok ? res.text() : null))
      .catch(() => null)
    markupCache.set(url, pending)
  }
  return pending
}
